<template>
  <v-container>
    <v-app-bar dense dark color="blue-grey darken-2">
      <v-spacer></v-spacer>
      <v-switch
          v-model="showCompleted"
          label="Show Completed Orders / 显示已完成订单"
          color="success"
          hide-details
          class="mt-4"
      ></v-switch>
    </v-app-bar>
    <v-row no-gutters class="mt-12">
    <v-col
        v-for="order in filteredOrders"
        :key="order.id"
        cols="12" sm="6" md="4" lg="3"
    >
      <v-card
          class="ma-2"
          :class="getCardClass(order)"
          elevation="2"
      >
        <v-card-title class="text-h5 d-flex justify-space-between">
          <span class="order-number">#{{ order.id }}</span>
          <span class="order-time">{{ formatTime(order.created_at) }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <div class="text-h6 mb-2">{{ order.customer_name }}</div>
          <div class="text-h4 font-weight-bold mb-4">{{ order.product_name }}</div>
          <div class="mb-2">
            <strong>
              Options / Sides
            </strong> <br>
            {{ order.options }}
          </div>

          <div v-if="order.extras && order.extras.length" class="mb-4">
            <strong>
              Extras
            </strong> <br>
            <v-chip
                v-for="(tag, index) in order.extras"
                :key="index"
                class="mr-2 mb-2"
                color="blue-grey"
                text-color="white"
            >
              {{ tag.name }}
            </v-chip>
          </div>

          <div class="text-subtitle-1" :class="order.has_been_cooked ? 'success--text' : 'grey--text'">
            {{ order.has_been_cooked ? 'Completed / 已完成' : 'Waiting: ' + getWaitTime(order.created_at) }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Empty state when no orders match filter -->
    <v-col v-if="filteredOrders.length === 0" cols="12" class="text-center pa-12">
      <v-icon size="64" color="grey lighten-1">mdi-food-off</v-icon>
      <div class="text-h5 grey--text mt-4">
        {{ showCompleted ? 'No completed orders' : 'No pending orders' }}
        <br>
        {{ showCompleted ? '没有已完成的订单' : '没有待处理的订单' }}
      </div>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
export default {
  name: "KitchenStaffHome",

  data: () => ({
    orders: [],
    refreshInterval: null,
    showCompleted: false
  }),

  computed: {
    filteredOrders() {
      return this.orders.filter(order =>
          this.showCompleted ? order.has_been_cooked : !order.has_been_cooked
      )
    }
  },

  created() {
    this.getOrders()
    this.refreshInterval = setInterval(this.getOrders, 30000)
  },

  destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },

  methods: {
    build_tags_obj(tag_string) {
      /**
       * Gets the tag string and creates
       * an array of objects from it.
       *
       * Example Str: Cheese:4,Extra Bacon:2 or null
       */
      if (!tag_string || typeof tag_string !== 'string') {
        return [];
      }
      try {
        const availableTags = [];
        const tagArray = tag_string.split(',');
        tagArray.forEach(tag => {
          // Trim whitespace
          tag = tag.trim();

          // Check if the tag has a colon (indicating it has an amount)
          if (tag.includes(':')) {
            // Split by colon to separate name and amount
            const [name, amount] = tag.split(':');
            // Add to availableTags as an object with name and amount
            availableTags.push({
              name: name.trim(),
              // Convert amount to number
              amount: parseInt(amount, 10)
            });
          } else {
            // If there's no colon, assume amount is 0
            availableTags.push({
              name: tag,
              amount: 0
            });
          }
        });
        return availableTags;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    getOrders() {
      this.$http.get(this.$http.defaults.baseURL + '/kitchen/orders/')
          .then((response) => {
            response.data.forEach((order) => {
              order.extras = this.build_tags_obj(order.tags)
            })
            this.orders = response.data
          })
          .catch((error) => {
            console.error("Failed to fetch orders:", error)
          })
    },

    setOrderStatus(order_id) {
      if (!confirm('Are you sure you want to set this order as completed / 您确定要将此订单设置为已完成吗 ?')) {
        return
      }

      this.$http.put(this.$http.defaults.baseURL + '/kitchen/orders/', {
        order_id: order_id,
      })
          .then(() => {
            this.getOrders()
          })
          .catch((error) => {
            console.error("Failed to update order:", error)
          })
    },

    formatTime(dateString) {
      const date = new Date(dateString)
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
    },

    getWaitTime(dateString) {
      const minutes = Math.floor((new Date() - new Date(dateString)) / 60000)

      if (minutes < 1) return 'Just now'
      if (minutes === 1) return '1 minute'
      if (minutes < 60) return `${minutes} minutes`

      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60

      if (hours === 1) {
        return remainingMinutes > 0
            ? `1 hour ${remainingMinutes} minutes`
            : '1 hour'
      }

      return remainingMinutes > 0
          ? `${hours} hours ${remainingMinutes} minutes`
          : `${hours} hours`
    },

    getCardClass(order) {
      if (order.has_been_cooked) return 'green lighten-4'

      const minutes = (new Date() - new Date(order.created_at)) / 60000
      if (minutes > 25) return 'red lighten-4'
      if (minutes > 10) return 'orange lighten-4'
      return ''
    }
  }
}
</script>

<style scoped>
.order-number {
  font-family: monospace;
  font-size: 1.5em;
}

.order-time {
  font-size: 1.2em;
}

.v-card {
  transition: background-color 0.3s ease;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}
</style>